/**
 * Event product date/time handling — PDP, quick view, search list.
 */
(function () {
  var ENDED_HIDDEN_CLASS = 'event-ended-hidden';

  function isTruthy(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function normalizeEventTimes(eventTimes) {
    if (!eventTimes) return null;

    var normalized = String(eventTimes)
      .replace(/WIB/i, '')
      .replace(/\u2013/g, '-')
      .replace('–', '-')
      .replace(/\./g, ':')
      .replace(/\s+/g, ' ')
      .trim();

    if (normalized.indexOf('00:00') !== -1) return null;
    return normalized;
  }

  function getEventStatus(eventDateStr, eventTimes) {
    var normalizedTimes = normalizeEventTimes(eventTimes);
    if (!eventDateStr || !normalizedTimes) return null;

    var startTime;
    var endTime;

    if (normalizedTimes.indexOf('-') !== -1) {
      var parts = normalizedTimes.split('-').map(function (t) { return t.trim(); });
      startTime = parts[0];
      endTime = parts[1];
    } else {
      startTime = normalizedTimes;
      var startParts = startTime.split(':').map(Number);
      if (startParts.some(isNaN)) return null;

      var defaultEnd = new Date();
      defaultEnd.setHours(startParts[0] + 1, startParts[1], 0, 0);
      endTime = defaultEnd.toTimeString().slice(0, 5);
    }

    if (!startTime || !endTime) return null;

    var startHourParts = startTime.split(':').map(Number);
    var endHourParts = endTime.split(':').map(Number);
    if ([startHourParts[0], startHourParts[1], endHourParts[0], endHourParts[1]].some(isNaN)) {
      return null;
    }

    var start = new Date(eventDateStr + 'T00:00:00');
    start.setHours(startHourParts[0], startHourParts[1], 0, 0);

    var end = new Date(eventDateStr + 'T00:00:00');
    end.setHours(endHourParts[0], endHourParts[1], 59, 999);

    var now = new Date();
    if (now < start) return 'before';
    if (now >= start && now <= end) return 'ongoing';
    if (now > end) return 'ended';
    return null;
  }

  function hideElement(el) {
    if (!el) return;
    el.hidden = true;
    el.style.setProperty('display', 'none', 'important');
    el.classList.add(ENDED_HIDDEN_CLASS);
    el.setAttribute('aria-hidden', 'true');
  }

  function applyEndedButton(btn) {
    btn.disabled = true;
    btn.classList.add('button--disabled');
    btn.classList.remove('button--primary');
    btn.hidden = false;
    btn.style.removeProperty('display');
    btn.classList.remove(ENDED_HIDDEN_CLASS);
    btn.removeAttribute('aria-hidden');
    btn.textContent = 'The event has ended';
  }

  function applyOngoingButton(btn) {
    btn.disabled = true;
    btn.classList.add('button--disabled');
    btn.classList.remove('button--primary');
    btn.hidden = false;
    btn.style.removeProperty('display');
    btn.classList.remove(ENDED_HIDDEN_CLASS);
    btn.removeAttribute('aria-hidden');
    btn.textContent = 'The event is ongoing';
  }

  function applyBeforeButton(btn) {
    btn.disabled = false;
    btn.classList.remove('button--disabled', ENDED_HIDDEN_CLASS);
    btn.classList.add('button--primary');
    btn.hidden = false;
    btn.style.removeProperty('display');
    btn.removeAttribute('aria-hidden');
  }

  function applyToPdpButton(btn) {
    if (!btn) return null;

    var eventDateStr = btn.dataset.eventDate;
    var eventTimes = btn.dataset.eventTimes;
    if (!eventDateStr || !eventTimes) return null;

    var status = getEventStatus(eventDateStr, eventTimes);
    if (!status) return null;

    if (status === 'before') {
      applyBeforeButton(btn);
      return status;
    }
    if (status === 'ongoing') {
      applyOngoingButton(btn);
      return status;
    }
    if (status === 'ended') {
      applyEndedButton(btn);
      return status;
    }
    return null;
  }

  function applyToStock(root) {
    var stockEl = root.querySelector('[data-event-product-stock]')
      || root.querySelector('.product-meta__stock-status');

    if (!stockEl) return;

    var eventDate = stockEl.dataset.eventDate;
    var eventTimes = stockEl.dataset.eventTimes;

    if (!eventDate || !eventTimes) {
      var btn = root.querySelector('[data-is-product-event="true"][data-event-date][data-event-times]')
        || root.querySelector('[id="add-to-cart-button"][data-event-date][data-event-times]');
      if (!btn) return;
      eventDate = btn.dataset.eventDate;
      eventTimes = btn.dataset.eventTimes;
    }

    if (!isTruthy(stockEl.dataset.isProductEvent) && !root.querySelector('[data-is-product-event="true"]')) {
      return;
    }

    if (getEventStatus(eventDate, eventTimes) === 'ended') {
      hideElement(stockEl);
    }
  }

  function applyToSearchButton(btn, meta) {
    if (!btn || !meta) return;

    btn.classList.remove('ais-hit--cart-button--loading');

    btn.setAttribute('data-event-date', meta.eventDate || '');
    btn.setAttribute('data-event-times', meta.eventTimes || '');

    if (meta.isProductEvent) {
      btn.setAttribute('data-is-product-event', 'true');
    }

    var status = getEventStatus(meta.eventDate, meta.eventTimes);

    if (status === 'ended') {
      hideElement(btn);
      return status;
    }

    btn.hidden = false;
    btn.style.removeProperty('display');
    btn.classList.remove(ENDED_HIDDEN_CLASS);
    btn.removeAttribute('aria-hidden');
    btn.disabled = false;
    btn.classList.remove('button--disabled');
    btn.classList.add('button--primary');

    if (meta.isProductEvent) {
      var registerLabel = (window.languages && window.languages.productFormRegister) || 'Register';
      btn.textContent = registerLabel;
    }

    if (status === 'ongoing') {
      applyOngoingButton(btn);
    }

    return status;
  }

  function applyToScope(scope) {
    var root = scope || document;

    root.querySelectorAll('[id="add-to-cart-button"][data-event-date][data-event-times]').forEach(applyToPdpButton);
    root.querySelectorAll('[data-is-product-event="true"][data-event-date][data-event-times]').forEach(function (btn) {
      // Stock indicator shares event attrs for hide-when-ended only — not a CTA button.
      if (btn.hasAttribute('data-event-product-stock')) {
        return;
      }
      if (!btn.classList.contains('ais-hit--cart-button')) {
        applyToPdpButton(btn);
      }
    });

    applyToStock(root);
  }

  function scheduleApplyToScope(scope) {
    applyToScope(scope);
    setTimeout(function () { applyToScope(scope); }, 50);
    setTimeout(function () { applyToScope(scope); }, 300);
  }

  function observeQuickView() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (node.matches && node.matches('[data-section-type="product-quick-view"]')) {
            scheduleApplyToScope(node);
            return;
          }

          if (node.querySelector) {
            var quickView = node.querySelector('[data-section-type="product-quick-view"]');
            if (quickView) scheduleApplyToScope(quickView);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.DossEventProductDate = {
    isTruthy: isTruthy,
    getEventStatus: getEventStatus,
    applyToScope: applyToScope,
    scheduleApplyToScope: scheduleApplyToScope,
    applyToSearchButton: applyToSearchButton,
    ENDED_HIDDEN_CLASS: ENDED_HIDDEN_CLASS
  };

  function boot() {
    scheduleApplyToScope(document);
    observeQuickView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    scheduleApplyToScope(document);
  });
})();
